import React from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <header className="mu-hero" id="home">
      <div className="container">
        <span className="mu-eyebrow-pill">
          Trusted by Artists &nbsp;•&nbsp; Music Promotion &nbsp;•&nbsp; AI EPK &nbsp;•&nbsp; Distribution
        </span>
        <h1>Where Music, Culture &amp; Creativity Come Alive</h1>
        <p>
          Discover the latest music, connect with emerging and established artists, explore
          fashion and lifestyle stories, and access professional music promotion and
          distribution services — all in one place.
        </p>
        <div className="mu-hero-cta">
          <Link to="/services" className="btn-mu-outline-light">Promote Your Music</Link>
          <a href="#epk" className="btn-mu-solid">Create Your EPK &rarr;</a>
        </div>
      </div>
    </header>
  );
}
